import { useEffect, useRef } from 'react'

let sharedObserver = null

function getObserver() {
  if (!sharedObserver) {
    sharedObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            sharedObserver.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.1, rootMargin: '0px 0px -6% 0px' }
    )
  }
  return sharedObserver
}

export function useReveal() {
  const ref = useRef(null)
  useEffect(() => {
    const el = ref.current
    if (!el) return
    el.setAttribute('data-reveal', '')
    getObserver().observe(el)
    return () => getObserver().unobserve(el)
  }, [])
  return ref
}

export function useRevealAll(containerRef, deps = []) {
  useEffect(() => {
    const container = containerRef?.current ?? document
    const els = container.querySelectorAll('[data-reveal], [data-reveal-slow], [data-reveal-stagger]')
    const obs = getObserver()
    els.forEach((el) => obs.observe(el))
    return () => els.forEach((el) => obs.unobserve(el))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef, ...deps])
}
